'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------- Component
/**
  * BreadcrumbSchema - Implements schema.org Breadcrumb
  *
  * Describes a webpage
  *
  * @example
    <BreadcrumbSchema data={data}>
  *
  * @param {array} data.breadcrumbs - Required. The url of the page.
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://schema.org/breadcrumb|Schema.org Breadcrumb Docs}
  */
var BreadcrumbSchema = function BreadcrumbSchema(props) {
  var schemaOrgJSONLD = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: props.data.breadcrumbs.map(function (breadcrumb, index) {
      return {
        '@type': 'ListItem',
        position: index,
        item: {
          '@id': breadcrumb.url,
          name: breadcrumb.name
        }
      };
    })
  };
  // console.log(JSON.stringify(schemaOrgJSONLD));

  return _react2.default.createElement(
    _reactHelmet2.default,
    null,
    _react2.default.createElement(
      'script',
      { type: 'application/ld+json' },
      JSON.stringify(schemaOrgJSONLD)
    )
  );
}; // ----------------------------------------------------------------------- Imports


BreadcrumbSchema.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
} : {};

BreadcrumbSchema.defaultProps = {
  data: {
    author: ''
  }
};

// ----------------------------------------------------------------------- Export
exports.default = BreadcrumbSchema;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/seo/lib/BreadcrumbSchema.js
// module id = 451
// module chunks = 168707334958949